import {Component} from "react";
import myEmitter from "./my-events";
import demo from "../imgs/demo.jpg";
import {Radio} from "antd";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import * as setAnswer from "../actions/evaluation";
import React from "react";
import {request,requestPost} from "../utils/Util";
const RadioGroup = Radio.Group;
class English extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
        }

        this.answer = {
            index: '',
            value:''
        };
        const {answer,currentEvaluation} = props;
        const {answers} = answer;
        if(answers[currentEvaluation.page]){
            this.state.value = answers[currentEvaluation.page].value;
        }
    }




    _handlerNextQuestion = (action)=>{
        this._doSetAnswer(action);
    }

    async _setAnswer(page,A){
        const {match,answercurrentEvaluation,answer} = this.props;
        var params = {
            url: window.location.href.split('question/')[1].replace(/\//g,'_'),
            info: JSON.stringify({...answer.answers,[page]:A})
        }

        const answerSet = await requestPost(`/questionnaires/test_questions_save/`,'POST', params);
        console.log(params,answerSet);
    }

    _doSetAnswer(action) {
        const {actions,currentEvaluation,match} = this.props;
        this.answer.index = currentEvaluation.page;
        this.answer.value = this.state.value;
        console.log(this.answer);
        this._setAnswer(currentEvaluation.page,{index:this.answer.index,value:this.answer.value});
        actions.setAnswer(currentEvaluation.page, this.answer, this.answer);
        // this._setAnswer(this.answer.index,this.answer.value);

    }

    keyLight(id){
        var m = document.getElementsByTagName('a');
        for(var i = 0; i<m.length; i++){
            if(m[i].getAttribute('qid') === id){
                console.log(m[i])
                var s = m[i].children[0].getAttribute('transform').split(' ')[1].replace(')','');
                document.getElementsByClassName('content')[0].scrollTo(0,parseInt(s));
                // m[i].setAttribute('fill','#ffc107')
                // m[i].setAttribute('filter','url(#solidBgColor)')
                m[i].getElementsByTagName("text")[0].setAttribute('filter','url(#solidBgColor)');
            }
        }
    }

    componentWillUnmount() {
        myEmitter.off('nextQuestion', this._handlerNextQuestion);
        myEmitter.off('prevQuestion', this._handlerNextQuestion);
    }

    componentDidMount() {
        myEmitter.on('nextQuestion', this._handlerNextQuestion);
        myEmitter.on('prevQuestion', this._handlerNextQuestion);
        const {answer,evaluation,currentEvaluation} = this.props;
        var h = evaluation.datas.content_object_content ? evaluation.datas.content_object_content.units[currentEvaluation.page] : '';
        if(!h) return;
        // add srv bg color filter def
        var bgFilterDef = document.createElementNS('http://www.w3.org/2000/svg','defs')
         bgFilterDef.innerHTML = ""+
            '<filter x="0" y="0" width="1" height="1" id="solidBgColor">'+
            '<feFlood flood-color="#ffff7b"></feFlood>'+
            '<feComposite in="SourceGraphic"></feComposite>'+
            '</filter>'+
            '';
        var svgNode = document.getElementsByClassName("content_reading")[0].getElementsByTagName("svg")[0];

        svgNode.insertBefore(bgFilterDef, svgNode.getElementsByTagName("g")[0]);
        //
        this.keyLight(h.questions.uuid);
    }


    onChange = (e) => {
        const {actions,currentEvaluation,evaluation} = this.props;
        console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value,
        },()=>{
            this._doSetAnswer('');
            // if(currentEvaluation.page === evaluation.datas.content_object_content.units.length-1){
            //     this._doSetAnswer('');
            // }
        });
    }
    render() {
        const radioGroupStyle = {
            display: 'block'
        };
        const radioStyle = {
            display: 'block',
            minHeight: '30px',
            paddingBottom: '10px',
            whiteSpace: 'normal',
            wordBreak: 'break-all'
        };

        const styles = {
            padding: '16px',
            // border: solid
            margin: '',
        }
        const {answer,evaluation,currentEvaluation} = this.props;
        var h = evaluation.datas.content_object_content ? evaluation.datas.content_object_content.units[currentEvaluation.page] : '';
        return (
            <div className='questionItem'>
                <div className='content content_reading'>
                    <div dangerouslySetInnerHTML={{__html: h.passage}}/>
                </div>
                <div className='options'>
                    {/*<div className='boxed-question-direction' style={styles}>Question 15 asks about the preceding passage as a whole.</div>*/}
                    <p  dangerouslySetInnerHTML={{__html: !h ? '' : h.questions.description}} />
                    <div className='options_group'>
                        <RadioGroup style={radioGroupStyle} onChange={this.onChange} value={this.state.value}>
                            {
                                h.questions.options && h.questions.options.map((item,index)=>{
                                    return <div className="optionsDiv">
                                        <div className="options_ratio">
                                            <Radio style={radioStyle} value={item.id}></Radio>
                                        </div>
                                        <div className="options_content">
                                            <span style={{marginRight:3}}>{item.letter}.</span>
                                            <span className='optionContent' dangerouslySetInnerHTML={{__html: item.value}}/>
                                        </div>

                                    </div>
                                    // <Radio style={radioStyle} value={item.id}>
                                    //     <span style={{marginRight:10}}>{item.letter} </span>
                                    //     <span className='optionContent' dangerouslySetInnerHTML={{__html: item.value}}/></Radio>
                                })
                            }
                        </RadioGroup>
                    </div>
                </div>
            </div>
        );
    }
}
English = connect((state) => ({
    evaluation: state.evaluation,
    currentEvaluation: state.currentEvaluation,
    answer: state.answer,
}), (dispatch) => ({
    actions: bindActionCreators(setAnswer, dispatch),
}))( English);

export {English};